import React from "react";

export const getStepItems = (type: string) => {
  const renderLineBreakTitle = (line1: string, line2: string) =>
    React.createElement(React.Fragment, null, line1, React.createElement("br"), line2);

  const secondStepTitle = (() => {
    switch (type) {
      case "QUOTA_GROUP":
        return "เพิ่มกลุ่มสินค้า";
      case "QUOTA_TOTAL":
        return "เลือกสินค้า";
      case "QUOTA_INDIVIDUAL":
        return renderLineBreakTitle("เลือกสินค้า", "และร้าน");
      default:
        return renderLineBreakTitle("เลือกสินค้า", "และร้าน");
    }
  })();

  const steps = [{ title: "รายละเอียด" }, { title: secondStepTitle }];

  if (type === "QUOTA_TOTAL") {
    steps.push({ title: "เลือกร้านค้า" });
  }

  return steps;
};
